import React, { useEffect } from "react";
import Modal from "react-modal";
import "./paymentpopup.css";
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
  },
};

// Make sure to bind modal to your appElement (https://reactcommunity.org/react-modal/accessibility/)
//   Modal.setAppElement('#yourAppElement');

function PaymentPopUp(props) {
  const handlePractice = () => {
    props.closeModal();
    props.playPractice();
  };
  return (
    <>
      <Modal
        isOpen={props?.show}
        onRequestClose={props.closeModal}
        style={customStyles}
        contentLabel="Example Modal"
        className="nmh"
      >
        <button className="closeModal" onClick={props.closeModal}>
          <img src={require("../../../Assets/img/corss-modal.png")} alt = ''/>
        </button>
        <img src={require("../../../Assets/img/warn.png")} className="warn" alt = '' />
        <p>Please Connect Wallet to Play and win game against worldwide players </p>  <p>or enjoy "Free game play"</p> <p className="practice_para" onClick={() => handlePractice()}>here</p>
       
      </Modal>
    </>
  );
}

export default PaymentPopUp;
